import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';
import { store } from '@Managers/Redux/Store';
import { setHttpError } from '@Managers/Redux/HttpState/HttpState';

// TYPES
import { HTTP_HEADER_DEFAULT, HttpMethodType, KibanaLogPayload, TCreditionals, TUserActionResponse } from './HttpService.types';
import { TUserAction } from '@Managers/Events/GameEvents';
import ConfigLoader from '@ConfigLoader/ConfigLoader';

class HttpService {
    private authenticateUrl = '';
    private userActionUrl = '';
    private kibanaUrl = '';
    private historyUrl = '';
    private getBalanceUrl = '';
    private quitRequestUrl = '';
    private getGameFixesUrl = '';

    constructor() {}

    private requestAction(data: { url: string; method: string; headers: any; payload?: any }) {
        return new Promise<TUserActionResponse>((resolve, reject) => {
            const requestOptions = {
                method: data.method,
                headers: data.headers,
                body: JSON.stringify(data.payload)
            };

            fetch(data.url, requestOptions)
                .then((response) => {
                    return response.json().then((data) => ({
                        data: data,
                        status: response.status
                    }));
                })
                .then((response) => {
                    if (response.status < 300) {
                        return response.data;
                    } else if (response.status === 503 && response.data?.isUnderMaintenance) {
                        return response.data;
                    } else {
                        store.dispatch(
                            setHttpError({
                                statusCode: response.status,
                                requestError: true,
                                code: response.data.code,
                                error: response.data.error
                            })
                        );
                        reject();
                        return false;
                    }
                })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    if (data.payload) {
                        store.dispatch(setHttpError({ actionName: data.payload?.actionName, actionPayload: data.payload, networkError: true }));
                    }

                    reject({ success: false, msg: error, error: 'NO DATA' });
                });
        });
    }

    public async checkUserSessionRequest(creditionals: TCreditionals) {
        Logger.log(LoggerLevel.HttpRequest, { source: LoggerSource.HttpService, message: 'SERVICES :: HTTP REQEST :: checkUserSessionRequest POST' });
        return await this.requestAction({
            url: this.authenticateUrl,
            method: HttpMethodType.POST,
            headers: HTTP_HEADER_DEFAULT,
            payload: creditionals
        });
    }

    public async userAction(data: TUserAction) {
        Logger.log(LoggerLevel.HttpRequest, { source: LoggerSource.HttpService, message: 'SERVICES :: HTTP REQEST :: userAction POST', data: data });
        return await this.requestAction({
            url: this.userActionUrl,
            method: HttpMethodType.POST,
            headers: {
                ...HTTP_HEADER_DEFAULT,
                Authorization: `Bearer ${ConfigLoader.getAuthToken()}`
            },
            payload: data
        });
    }

    public async getBalanceRequest() {
        return await this.requestAction({
            url: this.getBalanceUrl,
            method: HttpMethodType.POST,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${ConfigLoader.getAuthToken()}`
            }
        });
    }

    public async quitRequest() {
        return await this.requestAction({
            url: this.quitRequestUrl,
            method: HttpMethodType.POST,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'text/plain',
                Authorization: `Bearer ${ConfigLoader.getAuthToken()}`
            }
        });
    }

    public kibanaLog(data: Partial<KibanaLogPayload>) {
        return new Promise<{}>((resolve, reject) => {
            const requestOptions = {
                method: HttpMethodType.POST,
                headers: HTTP_HEADER_DEFAULT,
                body: JSON.stringify(data)
            };

            fetch(this.kibanaUrl, requestOptions)
                .then((response) => {
                    const data = response.text();
                })
                .then((data) => {})
                .catch((error) => {});
        });
    }

    public async historyRequest() {
        return await this.requestAction({
            url: this.historyUrl,
            method: HttpMethodType.POST,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${ConfigLoader.getAuthToken()}`
            }
        });
    }

    public async getFixesRequest() {
        return await this.requestAction({
            url: this.getGameFixesUrl,
            method: HttpMethodType.POST,
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${ConfigLoader.getAuthToken()}`
            }
        });
    }

    set(data: {
        authenticateUrl?: string;
        userActionUrl?: string;
        authToken?: string;
        kibanaUrl?: string;
        historyUrl?: string;
        getBalanceUrl?: string;
        quitRequest?: string;
        getGameFixes?: string;
    }) {
        if (data.authenticateUrl) this.authenticateUrl = data.authenticateUrl;
        if (data.userActionUrl) this.userActionUrl = data.userActionUrl;
        if (data.kibanaUrl) this.kibanaUrl = data.kibanaUrl;
        if (data.historyUrl) this.historyUrl = data.historyUrl;
        if (data.getBalanceUrl) this.getBalanceUrl = data.getBalanceUrl;
        if (data.quitRequest) this.quitRequestUrl = data.quitRequest;
        if (data.getGameFixes) this.getGameFixesUrl = data.getGameFixes;
    }
}

export default new HttpService();
